export const ZERO_STEP = "v2/establishment/signup-account";
export const FIRST_STEP = (id) => `v2/establishment/signup-account/${id}`;
export const SECOND_STEP = "v2/establishment/signup-ngo";
export const THIRD_STEP = "v2/establishment/signup-members";
